import {
  AccredibleExpansionPanelComponent,
  ExpansionPanelTriggerConfig,
} from '@accredible-frontend-v2/new-components/expansion-panel';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'dod-faq',
  standalone: true,
  imports: [CommonModule, AccredibleExpansionPanelComponent, TranslocoModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class DoDFaqComponent {
  private readonly _language = inject(AccredibleLanguageService);

  private readonly faqIndexes = signal(Array.from({ length: 9 }, (_, i) => i + 1));

  protected readonly triggerConfigs = computed(() => {
    return this.faqIndexes().map((index) => ({
      style: 'div',
      width: 'full',
      expandText: this._language.translate(`faq.questions.q${index}`),
      collapseText: this._language.translate(`faq.questions.q${index}`),
      expandGroup: 'faq',
    })) as ExpansionPanelTriggerConfig[];
  });
}
